import {Component, HostListener, OnDestroy, OnInit} from '@angular/core';
import {LoginService} from "../login/login.service";
import {HeaderService} from "./header.service";
import {ActivatedRoute, Router} from "@angular/router";
import {LoginEvent} from "../../model/login-event";
import {UserGuardService} from '../../common/user-guard.service';

@Component({
  selector: 'pbc-header',
  templateUrl: './header.component.html'
})
export class HeaderComponent implements OnInit, OnDestroy{

  isUserLogged: boolean = false;
  isAdmin : boolean = false;
  isClient : boolean = false;
  userInitials: string = "";
  userFirstName : string = "";
  userLastName : string = "";
  userEmail : string = "";
  showLoginRegisterButtons = false;
  showRedUnderline = true;
  isHomePage = true;
  addSticky = false;
  userId: number;

  constructor(
      private loginService: LoginService,
      private headerService: HeaderService,
      private router: Router,
      private userGuardService: UserGuardService,
  ) { }

  @HostListener('window:scroll', ['$event'])
  onScroll() {
    if(window.pageYOffset > 0) {
      this.addSticky=true;
    } else {
      this.addSticky=false;
    }
  }

  private static shortenEmail(email : string) : string {
    let result : string="";
    if (email.length > 25) {
      let userName = email.split('@')[0];
      let domain = email.split('@')[1];
      let domainAfterDot = domain.split('.')[1];
      result = userName.concat('@', domain.substr(0,4),'....',domainAfterDot);
    } else
      return email;

    return result;
  }

  ngOnInit() {
    this.loginService.loginEvent.subscribe(
      (loginEvent: LoginEvent) => {
        this.isUserLogged = loginEvent.isUserLogged;
        this.isClient = loginEvent.isClient;
        this.isAdmin = loginEvent.isAdmin;
        if (this.isUserLogged) {
          let authData = JSON.parse(localStorage.getItem('auth_data'));
          this.userId = authData.user.id;
          this.userInitials = (authData.user.firstName.charAt(0)+authData.user.lastName.charAt(0));
          this.userFirstName = authData.user.firstName;
          this.userLastName = authData.user.lastName;
          this.userEmail = HeaderComponent.shortenEmail(authData.user.email);
          this.isAdmin = authData.user.isAdmin;
          this.showLoginRegisterButtons = false;
        } else
          this.showLoginRegisterButtons = true;
      }
    );
    this.headerService.showLoginRegisterButtons.subscribe(
      (showLoginRegisterButtons: boolean) => {
        this.showLoginRegisterButtons = showLoginRegisterButtons;
      }
    );
    this.headerService.showRedUnderline.subscribe(
      (showRedUnderline: boolean) => {
        this.showRedUnderline = showRedUnderline;
      }
    );
    this.headerService.isHomePage.subscribe(
      (isHomePage: boolean) => {
        this.isHomePage = isHomePage;
      }
    );

    let canActivate = this.userGuardService.canActivate();
  }
  ngOnDestroy() {
    this.loginService.loginEvent.unsubscribe();
    this.headerService.showLoginRegisterButtons.unsubscribe();
    this.headerService.showRedUnderline.unsubscribe();
    this.headerService.isHomePage.unsubscribe();
  }
  onLogoClick() {
    this.headerService.setFirstPositionOnTopMenu.emit(true);
  }
}
